










































































































import { defineComponent, onMounted, ref } from '@vue/composition-api';

import useAuth from '@/useAuth';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonPartOfSidebar from '@/components/CommonPartOfSidebar.vue';

const AppLivePlatform = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonPartOfSidebar,
  },
  setup() {
    const { getMe, hasPermission } = useAuth();
    const me = ref({});
    onMounted(async () => {
      me.value = await getMe();
    });

    const currentExpand = ref('');

    return {
      me,
      hasPermission,
      currentExpand,
    };
  },
});

export default AppLivePlatform;
